class HeightObserver extends HTMLDivElement {
  constructor() {
    super()
    this.resizeObserver = new ResizeObserver(this.updateHeight.bind(this))
    this.customEventHandler = this.updateHeight.bind(this)
  }

  connectedCallback() {
    this.updateHeight()

    // Check if there's a custom event name to listen for
    const eventName = this.dataset.eventName
    if (eventName) {
      document.addEventListener(eventName, this.customEventHandler)
    }
  }

  disconnectedCallback() {
    // Stop observing when the element is disconnected from the DOM
    this.resizeObserver.disconnect()

    // Remove custom event listener if it was added
    const eventName = this.dataset.eventName
    if (eventName) {
      document.removeEventListener(eventName, this.customEventHandler)
    }
  }

  updateHeight() {
    this.parentElement.style.setProperty(
      '--child-height',
      `${this.getBoundingClientRect().height}px`
    )
  }
}

customElements.define('height-observer', HeightObserver, { extends: 'div' })
